'use client';
import { Box, DsmColor, Grid, GridColumn, Carousel, CarouselSlide, Typography, omitText } from '@kohler-dsm-library/kohler-core';
import { ArrowRightIcon, ArrowLeftIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import Autoplay from 'embla-carousel-autoplay';
import React, { useRef, useMemo, Fragment } from 'react';
import classes from './PromoBanner.module.css.mjs';

const PromoBanner = ({
  content,
  carouselControlProps,
  autoplay = true,
  autoplayDelay = 5e3
}) => {
  const autoplayPluginRef = useRef(autoplay ? Autoplay({ delay: autoplayDelay }) : null);
  const plugins = useMemo(() => autoplayPluginRef.current ? [autoplayPluginRef.current] : void 0, [autoplayPluginRef.current]);
  const handleMouseEnter = () => {
    autoplayPluginRef.current?.stop();
  };
  const handleMouseLeave = () => {
    autoplayPluginRef.current?.play();
  };
  return /* @__PURE__ */ React.createElement(Box, { className: clsx(classes.promoBanner, "kohler-promo-banner-root"), backgroundColor: DsmColor.BackgroundPrimary }, /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, null, /* @__PURE__ */ React.createElement(
    Carousel,
    {
      maxWidth: "min(760px, calc(100% - 2 * 30px))",
      withControls: content.length > 1,
      draggable: content.length > 1,
      includeGapInSize: false,
      style: { justifySelf: "center" },
      loop: true,
      plugins,
      onMouseEnter: autoplay ? handleMouseEnter : void 0,
      onMouseLeave: autoplay ? handleMouseLeave : void 0,
      carouselControlProps: { ...carouselControlProps },
      customLeftControl: /* @__PURE__ */ React.createElement(Box, { component: "button", type: "button", display: "flex", textColor: DsmColor.ContentPrimary, "aria-label": "go to previous slide" }, /* @__PURE__ */ React.createElement(ArrowLeftIcon, { withBoundingBox: true, size: "small" })),
      customRightControl: /* @__PURE__ */ React.createElement(Box, { component: "button", type: "button", display: "flex", textColor: DsmColor.ContentPrimary, "aria-label": "go to next slide" }, /* @__PURE__ */ React.createElement(ArrowRightIcon, { withBoundingBox: true, size: "small" }))
    },
    content.map((message, index) => /* @__PURE__ */ React.createElement(CarouselSlide, { key: `promo-banner-${index}`, className: classes.promoBannerSlide }, /* @__PURE__ */ React.createElement(Box, { component: "div", textAlign: "center", maxWidth: 700, style: { justifySelf: "center" }, marginInline: 30 }, /* @__PURE__ */ React.createElement(Typography, { size: "label-medium-xs", textColor: DsmColor.ContentPrimary, component: "span" }, message.content), message.CTAs && /* @__PURE__ */ React.createElement(Fragment, null, message.CTAs.map((link) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      /* @__PURE__ */ React.createElement(
        Typography,
        {
          component: "href" in link && link.href ? "a" : "button",
          size: "label-medium-xs",
          textDecoration: "underline",
          textColor: DsmColor.ContentPrimary,
          whiteSpace: "nowrap",
          key: link.text,
          className: classes.inlineLink,
          ...omitText(link)
        },
        link.text
      )
    ))))))
  ))));
};

export { PromoBanner };
